import { EmptyRouteComponent } from './modules/shared/empty-route/empty-route.component';
import { LayoutModule } from './modules/layout/layout.module';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'asp'
  },
  {
    path: 'asp',
    loadChildren: () => LayoutModule
  },
  {
    path: '**',
    component: EmptyRouteComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [{ provide: APP_BASE_HREF, useValue: '/asp/' }],
  exports: [RouterModule],
})
export class AppRoutingModule { }
